// extracted by mini-css-extract-plugin
export default {"slidesShown":"7","error":"_variables_error__sEX3t"};